/* eslint-disable indent,import/prefer-default-export */
import fr from 'facet-rest';
import DotCheckbox from 'Components/UI/DotCheckbox';

export const EmailAddressMetaOverride = fr
  .meta()
    .template()
      .addFilter('emailAttrsOnly', v => ['address', 'type'].includes(v.attr('name')))
      .pushItem('address')
        .attr('ordinal', 1)
        .parent()
      .pushItem('type')
        .attr('ordinal', 2)
        .options()
          .orderBy('prompt')
          .parent()
        .parent()
      .pushItem('isPreferred')
        .attr('ordinal', 3)
        .attr('_component', DotCheckbox)
        .parent()
      .parent();
